import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const deleteRateSchedule = {
  name: 'deleteRateSchedule',
  state: {
    loading: false,
    error: '',
  },
  reducers: {
    deleteRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    deleteSucceeded(state) {
      return {
        ...state,
        loading: false,
        error: '',
      };
    },

    deleteFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async removeRateSchedule(id) {
      try {
        this.deleteRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const orgId = userInfo?.org_id;
        const url = `savvy/rate-schedule/${id}?user_id=${userInfo.id}&org_id=${orgId}`;
        const response = await http.delete(url);
        const displayResponse = await http.get(`savvy/displays/lookupDisplays/${orgId}`);
        const rateSchedulesResponse = await http.get(`savvy/rate-schedule/lookup/${orgId}`);
        if (response && response.data) {
          if (rateSchedulesResponse?.data?.data?.length === 0)
            await dispatch.ProgressStepDSO.DeleteDSOProgressStep(2);
          else if (displayResponse?.data?.data?.length === 0)
            await dispatch.ProgressStepDSO.DeleteDSOProgressStep(3);
          this.deleteSucceeded();
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'success',
              message: 'Rate schedule deleted successfully!',
              show: true,
            },
          });
        }
      } catch (err) {
        this.deleteFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default deleteRateSchedule;

